var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.852058 7.32882C0.770233 7.32844 0.690425 7.3034 0.623041 7.25698C0.555657 7.21056 0.503827 7.14491 0.474309 7.06859C0.444791 6.99228 0.438957 6.90884 0.457567 6.82916C0.476176 6.74947 0.518366 6.67725 0.578634 6.6219L3.5997 3.8771L0.578634 1.12864C0.537298 1.09327 0.503489 1.04995 0.479212 1.00126C0.454935 0.952567 0.440685 0.899497 0.437307 0.845195C0.433929 0.790893 0.441493 0.736466 0.459549 0.685142C0.477605 0.633819 0.505785 0.586645 0.542419 0.546419C0.579052 0.506193 0.623392 0.473735 0.672807 0.45097C0.722223 0.428205 0.775707 0.415598 0.830087 0.413895C0.884468 0.412193 0.938636 0.42143 0.989379 0.44106C1.04012 0.460689 1.0864 0.49031 1.12548 0.528166L4.47685 3.57686C4.51868 3.61494 4.5521 3.66133 4.57497 3.71307C4.59783 3.7648 4.60964 3.82074 4.60964 3.8773C4.60964 3.93387 4.59783 3.98981 4.57497 4.04154C4.5521 4.09328 4.51868 4.13967 4.47685 4.17775L1.12548 7.22319C1.04707 7.29389 0.949564 7.32882 0.852058 7.32882Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGrey);
export default __webpack_public_path__ + "static/media/right_arrow_grey.84d28e0e774ff7974b8494f30d1371db.svg";
export { ForwardRef as ReactComponent };